module.exports = __webpack_public_path__ + "static/media/whatIsEvent_48.53bc57f6.png";